<template>
  <div id="app">
    <router-view />
    <BackTop/>
  </div>
</template>
<script>
const BackTop = () => import("./components/backToTop.vue");
export default {
  components: {
    BackTop,
  },
};
</script>
<style lang="scss">

#app{
  height: 100vh;
  // background-color: #fcfcfc;
}
</style>
